import { render, staticRenderFns } from "./uploadNew.vue?vue&type=template&id=4010e39a&scoped=true"
import script from "./uploadNew.vue?vue&type=script&lang=js"
export * from "./uploadNew.vue?vue&type=script&lang=js"
import style0 from "./uploadNew.vue?vue&type=style&index=0&id=4010e39a&prod&lang=scss&scoped=true"
import style1 from "./uploadNew.vue?vue&type=style&index=1&id=4010e39a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010e39a",
  null
  
)

export default component.exports